import { css } from "styled-components";

const hoverTips = (theme, tips, left = "-50%", top = "-90%") => {
  return css`
    position: relative;

    :hover {
      /* tips */
      ::after {
        content: "${tips}";
        white-space: nowrap;
        position: absolute;
        left: ${left};
        top: ${top};
        border: solid 1px ${theme?.backgroundColor};
        box-shadow: ${theme?.boxShadow};
        background-color: white;
        color: ${theme?.dark};
        letter-spacing: 1.5px;
        font-size: ${theme?.fontSize?.small};
        padding: 2px 5px;
      }
    }
  `;
};

export { hoverTips };
